const normalizeText = (value) => String(value ?? "").trim();

const EMPTY_ALERT_FILTERS = { priority: "", province: "", responsible: "", status: "" };

const ALERT_FILTER_FIELDS = {
  priority: "priority",
  province: "province",
  responsible: "responsibleName",
  status: "status",
};

const buildAlertFilterOptions = (rows = []) => {
  const collect = (field) =>
    Array.from(new Set(rows.map((item) => item?.[field]).filter(Boolean)))
      .sort((first, second) => first.localeCompare(second, "es"));

  return {
    priority: collect(ALERT_FILTER_FIELDS.priority),
    province: collect(ALERT_FILTER_FIELDS.province),
    responsible: collect(ALERT_FILTER_FIELDS.responsible),
    status: collect(ALERT_FILTER_FIELDS.status),
  };
};

const applyAlertFilters = (rows = [], filters = EMPTY_ALERT_FILTERS) =>
  rows.filter((item) =>
    Object.keys(EMPTY_ALERT_FILTERS).every((key) => {
      const selected = normalizeText(filters?.[key]);
      return !selected || item?.[ALERT_FILTER_FIELDS[key]] === selected;
    })
  );

const hasActiveAlertFilters = (search, filters = EMPTY_ALERT_FILTERS) =>
  Boolean(normalizeText(search)) ||
  Object.keys(EMPTY_ALERT_FILTERS).some((key) => Boolean(normalizeText(filters?.[key])));

export {
  ALERT_FILTER_FIELDS,
  applyAlertFilters,
  buildAlertFilterOptions,
  EMPTY_ALERT_FILTERS,
  hasActiveAlertFilters,
};
